/* eslint-disable */
const fromMarkdown = require('./fromMarkdown');

const OPEN_BRACKET = 91; // [

const CLOSE_BRACKET = 93; // ]

export default function (options = {}) {
  const data = this.data();
  const call = {
    tokenize: tokenizeShortcuts
  };
  const text = {
    [OPEN_BRACKET]: call
  };

  function add(field, value) {
    if (data[field]) {
      data[field].push(value);
    } else {
      data[field] = [value];
    }
  }

  add('micromarkExtensions', {
    text
  });
  add('fromMarkdownExtensions', fromMarkdown);
}

function tokenizeShortcuts(effects, ok, nok) {
  let size = 0;
  let data;
  return start;

  function start(code) {
    if (code !== OPEN_BRACKET) {
      return nok(code);
    }

    effects.enter('shortcodeCall');
    effects.enter('shortcodeCallLabelMarker');
    effects.consume(code);
    effects.exit('shortcodeCallLabelMarker');
    return callStart;
  }

  function callStart(code) {
    if (code !== OPEN_BRACKET) {
      return nok(code);
    }

    effects.enter('shortcodeCallMarker');
    effects.consume(code);
    effects.exit('shortcodeCallMarker');
    effects.enter('shortcodeCallString');
    effects.enter('chunkString').contentType = 'string';
    return callData;
  }

  function callData(code) {
    if (code === null || code === OPEN_BRACKET || size++ > 999) {
      return nok(code);
    }

    if (code === CLOSE_BRACKET) {
      if (!data) {
        return nok(code);
      }

      effects.exit('chunkString');
      effects.exit('shortcodeCallString');
      return almostEnd(code);
    }

    effects.consume(code);

    if (!(code < 0 || code === 32)) {
      data = true;
    }

    return callData;
  }

  function almostEnd(code) {
    // Always a `]`.
    effects.enter('shortcodeCallLabelMarker');
    effects.consume(code);
    effects.exit('shortcodeCallLabelMarker');
    return end;
  }

  function end(code) {
    if (code !== CLOSE_BRACKET) {
      return nok(code);
    } // Always a `]`.


    effects.enter('shortcodeCallLabelMarker');
    effects.consume(code);
    effects.exit('shortcodeCallLabelMarker');
    effects.exit('shortcodeCall');
    return ok;
  }
}